import {DataTable} from "simple-datatables";
import columnMap from "./columns.json";
import {normalize} from "@brandextract-dev/workstrings-data/lib/normalize";

//const table = document.querySelector("#spec-sheet-table");

const selectedState = {
  imperial: true,
};

window.system = "Imperial";

let searchState = {
  "search": "",
  "od": {
    "terms": [],
    "column": 1
  },
  "range": {
    "terms": [],
    "column": 2
  }
};

let selectedSheet = "Drill Pipe";
let dataTable;
let tableData = {};

function searchByFloat(terms, cell, row, _column, source) {
  let found;
  if (source === "float-filter" || source === "search") {
    const cellValue = cell.data[0].data;
    found = terms.find(
      term => {
        let termValue = term;
        termValue = termValue.replaceAll("-", "/");
        termValue = termValue.replaceAll("d", ".");
        return cellValue === termValue;
      }
    )
  } else {
    // This is normal search. We just check if one of the terms is part of the text of the cell
    found = terms.find(
      term => cell.text.toLowerCase().includes(term.toLowerCase().trim())
    );
  }
  if (found) return true;
  return false;
}

function responsiveColumns() {
  if(selectedState[selectedSheet]) {
    changeColumnDisplay();
    return true;
  }

  let columns = 999;

  const xsMediaQuery = window.matchMedia("(max-width: 400px)");
  const smMediaQuery = window.matchMedia("(max-width: 576px)");
  const mdMediaQuery = window.matchMedia("(max-width: 768px)");
  const lgMediaQuery = window.matchMedia("(max-width: 1024px)");
  const xlMediaQuery = window.matchMedia("(max-width: 1200px)");
  const xl2MediaQuery = window.matchMedia("(max-width: 1440px)");
  const xl3MediaQuery = window.matchMedia("(max-width: 1920px)");

  // if (xsMediaQuery.matches) {
  //   columns = 2;
  // } else if (smMediaQuery.matches) {
  //   columns = 3;
  // } else if (mdMediaQuery.matches) {
  //   columns = 5;
  // } else if (lgMediaQuery.matches) {
  //   columns = 7;
  // } else if (xlMediaQuery.matches) {
  //   columns = 10;
  // } else if (xl2MediaQuery.matches) {
  //   columns = 12;
  // }

  if (columns) {
    $$("#toggle-list input").forEach((input,index) => {
      if (index >= columns) {
        input.checked = false;
      } else {
        input.checked = true;
      }
    });
    changeColumnDisplay();
  }
}

function initDataTable(table) {
  const columnData = columnMap[selectedSheet].columns;
  const columns = [];
  columnData.forEach((column, index) => {
    if (column.label === "OD") {
      columns.push({
        select: index,
        searchMethod: searchByFloat,
        sort: "asc",
        render: function(value, cell, rowIndex, cellIndex) {
          const data = value[0]?.data;
          if (data === null || isNaN(data)) {
            return "";
          }
          if (selectedState.imperial) {
            return normalize(data, {imperial_unit: column.imperial, convert: false, units: false, fraction: true, fixed: 3}).trim();
          } else {
            return data;
          }
        }
      });
    }
    if (column.label === "Range") {
      columns.push({
        select: index,
        searchMethod: searchByFloat,
      });
    }
    if (column.commas) {
      columns.push({
        select: index,
        render: function(value, cell, rowIndex, cellIndex) {
          const data = value[0]?.data;
          if (data === null || isNaN(data)) {
            return "";
          }
          const numberFormat = new Intl.NumberFormat('en-US');
          const numberWithCommas = numberFormat.format(data);
          return numberWithCommas;
        }
      });
    }
  });

  const dataTable = new DataTable(table, {
    paging: false,
    searchable: false,
    numeric: true,
    columns: columns
  });

  dataTable.on('datatable.update', function(query, matched) {
    const body = table.querySelector("tbody");
    const head = table.querySelector("thead");
    const columnCount = head.querySelector("tr").children.length;

    if (body.children.length === 0) {
      const tr = document.createElement("tr");
      const td = document.createElement("td");
      td.setAttribute("colspan", columnCount);
      td.classList.add("datatable-empty");
      td.textContent = "No results match your search query";
      tr.appendChild(td);
      body.appendChild(tr);
    }
  });

  responsiveColumns();
  return dataTable;
}

function initSelectedState() {
  const localImperial = localStorage.getItem("imperial");

  if (localImperial !== null) {
    if (localImperial === "true") {
      selectedState.imperial = true;
      window.system = "Imperial";
    } else {
      selectedState.imperial = false
      window.system = "Metric";
    }
  }
}

function changeColumnDisplay() {
  const table = $("#spec-sheet-table");
  const toggleList = $$("#toggle-list input");
  table.classList = "datatable-table";

  toggleList.forEach((input, index) => {
    if (input.checked) {
      table.classList.add(`[&_tr>*:nth-child(${index+1})]:!table-cell`);
    }
  });
}

function hideColumn(index) {
  const thead = $("#spec-sheet-table thead");
  const tbody = $("#spec-sheet-table tbody");

  $$("th", thead)[index].classList.add("hidden");
  $$("tr", tbody).forEach(row => {
    $$("td", row)[index].classList.add("hidden");
  });
}

function showColumn(index) {
  const thead = $("#spec-sheet-table thead");
  const tbody = $("#spec-sheet-table tbody");

  $$("th", thead)[index].classList.remove("hidden");
  $$("tr", tbody).forEach(row => {
    $$("td", row)[index].classList.remove("hidden");
  });
}

function clearFilters() {
  searchState.search = "";
  searchState.od.terms = [];
  searchState.range.terms = [];

  $$("#filter-list input").forEach(input => {
    input.checked = false;
  });
}

function clearSearch() {
  clearFilters();
  $("input[name='specsheet-search']").value = "";
}

function searchTable() {
  const {search, od, range} = searchState;

  dataTable.multiSearch([
    {
      terms: [search]
    },
    {
      terms: od.terms,
      columns: [od.column]
    },
    {
      terms: range.terms,
      columns: [range.column]
    },
  ], "search");

  const body = $("#spec-sheet-table tbody");
  const rows = body.querySelectorAll("tr:not(:has(.datatable-empty))");
  const rowCount = rows.length;
  $("#spec-sheet-live").textContent = `${rowCount} results found`;
}

function changeSheetPerQueryString() {
  const urlParams = new URLSearchParams(window.location.search);
  const sheetParam = urlParams.get("sheet");

  if (sheetParam) {
    selectedSheet = sheetParam.replaceAll("-", " ");
    loadData(selectedSheet);
  } else {
    selectedSheet = "Drill Pipe";
    loadData(selectedSheet);
  }

  $$("#spec-sheet-tabs button").forEach(button => {
    if (button.dataset.label === selectedSheet) {
      button.setAttribute("aria-selected", "true");
    } else {
      button.setAttribute("aria-selected", "false");
    }
  });
}

function loadData(sheet) {
  clearSearch();

  if (!selectedState.imperial) {
    $("input[name='specsheet-units']").checked = true;
  }

  $$("#spec-sheet-table tbody td.hidden").forEach(td => {
    td.classList.remove("hidden");
  });

  if (dataTable) {
    clearSearch();
    searchTable();
    dataTable.destroy();
  }
  const sheetColumnMap = columnMap[sheet];
  const sheetDataLabel = sheetColumnMap.dataLabel;
  const data = tableData[sheetDataLabel];
  const toggleList = document.querySelector("#toggle-list");
  const thead = $("#spec-sheet-table thead");
  const tbody = $("#spec-sheet-table tbody");
  thead.innerHTML = "";
  tbody.innerHTML = "";
  toggleList.innerHTML = "";

  const headTR = document.createElement("tr");
  sheetColumnMap.columns.forEach((column, index) => {
    const th = document.createElement("th");
    const li = document.createElement("li");
    const input = document.createElement("input");
    const label = document.createElement("label");

    input.setAttribute("name", `toggle-column-${index}`);
    input.setAttribute("value", index);
    input.setAttribute("type", "checkbox");
    input.setAttribute("id", `column-toggle-${index}`);
    input.checked = true;
    if (selectedState[sheet] && selectedState[sheet][index] === false) {
      input.checked = false;
    }
    label.setAttribute("for", `column-toggle-${index}`);
    label.textContent = column.label;
    li.appendChild(input);
    li.appendChild(label);

    if (column.imperial && column.metric) {
      let unit = column.metric;

      if (selectedState.imperial) {
        unit = column.imperial;
      }

      th.textContent = `${column.label} (${unit})`;
    } else {
      th.textContent = column.label;
    }

    if(selectedState[sheet]?.[index] === false) {
      th.classList.add("hidden");
    }

    toggleList.appendChild(li);
    headTR.appendChild(th);

    input.addEventListener("change", event => {
      event.preventDefault();
      const index = parseInt(event.target.value);

      if (selectedState[selectedSheet]) {
        selectedState[selectedSheet][index] = event.target.checked;
      } else {
        $$("#toggle-list input").forEach((input,index) => {
          selectedState[selectedSheet] = [];
          selectedState[selectedSheet][index] = input.checked;
        });
      }

      changeColumnDisplay();
    });
  });
  thead.appendChild(headTR);

  let uniqueOD = [];
  let uniqueRange = [];
  let odID = 0;
  let rangeID = 0;

  data.forEach(row => {
    const tr = document.createElement("tr");

    sheetColumnMap.columns.forEach((column, index) => {
      const td = document.createElement("td");
      let fixed = 3;
      if (!selectedState.imperial) {
        fixed = 2;
      }

      if (column.label === "PDF") {
        const link = document.createElement("a");
        let folder = selectedSheet.replaceAll(" ", "-");
        folder = folder.replaceAll("™", "");
        let id = row["opus"];
        id = id.replaceAll("*", "");
        id = id.replaceAll(" ", "-");
        const units = selectedState.imperial ? "Imperial" : "Metric";
        const href= `/assets/Spec-Sheets/${selectedSheet}/${id}-${units}.pdf`;
        link.href = href;
        link.setAttribute("target", "_blank");
        link.setAttribute("class","icon");
        link.setAttribute("aria-label", "Download Spec Sheet PDF");
        link.textContent = "Download";
        td.appendChild(link);
      } else if (column.label === "Type" && sheet === "HWDP") {
        const dataLabel = column.dataLabel;
        const value = row[dataLabel];
        if (value === "FALSE") {
          td.textContent = "Standard";
        } else {
          td.textContent = "Integral";
        }
      } else if (column.label === "Connection") {
        const dataLabel = column.dataLabel;
        const value = row[dataLabel];
        td.textContent = value;
      } else if (column.label === "Min MUT" || column.label === "Max MUT" || column.label === "Opt MUT" || column.label === "TJ Yield") {
        const dataLabel = column.dataLabel;
        let value = row[dataLabel];
        let multiplier = 1;

        if (column.fixed !== undefined) {
          fixed = column.fixed;
        }

        if (row["ff115only"] === "true") {
          multiplier = 1.15;
        }

        if (column.imperial && column.metric && !selectedState.imperial) {
          value = normalize(value, {imperial_unit: column.imperial, metric_unit: column.metric, units: false, fixed: fixed, metric_fixed: fixed, multiplier: multiplier}).replaceAll(",","");
        } else {
          value = normalize(value, {imperial_unit: column.imperial, convert: false, units: false, fixed: fixed, metric_fixed: fixed, multiplier: multiplier}).replaceAll(",","");
        }

        if (value === "0" || value === "N/A") {
          value = "";
        }

        td.textContent = value;
      } else {
        const dataLabel = column.dataLabel;
        let value = row[dataLabel];
        if (column.imperial && column.metric && !selectedState.imperial) {
          if (value) {
            if (column.fixed !== undefined) {
              fixed = column.fixed;
            }
            value = normalize(value, {imperial_unit: column.imperial, metric_unit: column.metric, force: true, units: false, metric_fixed: fixed}).replaceAll(",","");
          }
        } else if (selectedState.imperial && column.fractional) {
          value = normalize(value, {imperial_unit: column.imperial, convert: false, units: false, fixed: 3}).trim();
        } else {
          if (column.fixed !== undefined) {
            fixed = column.fixed;
          }
          if (value) {
            value = normalize(value, {imperial_unit: column.imperial, convert: false, units: false, fixed: fixed}).replaceAll(",","");
          }
        }
        // if (selectedState.imperial && column.fractional) {
        //   const fraction = new Fraction(value);
        //   value = fraction.simplify(0.001).toFraction(true);
        // }

        if (value === "0" || value === "N/A") {
          value = "";
        }

        td.textContent = value;

        if (column.label === "OD") {
          odID = index;
          if (!uniqueOD.includes(value)) {
            uniqueOD.push(value);
          }
        }
        if (column.label === "Range") {
          rangeID = index;
          if (!uniqueRange.includes(value)) {
            uniqueRange.push(value);
          }
        }
      }

      if(selectedState[sheet]?.[index] === false) {
        td.classList.add("hidden");
      }

      tr.appendChild(td);
    });

    tbody.appendChild(tr);
  });

  function createFilterButton (name, value, callback) {
    const li = document.createElement("li");
    const span = document.createElement("span");
    const input = document.createElement("input");
    const label = document.createElement("label");

    input.setAttribute("name", name);
    input.setAttribute("value", value);
    input.setAttribute("type", "checkbox");
    input.checked = false;
    span.textContent = value;
    label.appendChild(input);
    label.appendChild(span);
    li.appendChild(label);

    input.addEventListener("change", callback);

    return li;
  }

  const filterODGroup = document.querySelector("#filter-list .filter-od-group");
  const filterODList = document.querySelector("#filter-list .filter-od-group ul");
  filterODList.innerHTML = "";

  if (uniqueOD.length > 0) {
    uniqueOD.sort((a, b) => parseFloat(a) - parseFloat(b));
    if (selectedState.imperial) {
      uniqueOD = uniqueOD.map((od) => {
        return normalize(od, {imperial_unit: "in", convert: false, units: false, fraction: true, fixed: 3}).trim();
      });
    }

    uniqueOD.forEach((od, index) => {
      const li = createFilterButton("toggle-od", od, function() {
        let value = this.value.replaceAll("/", "-");
        value = value.replaceAll(".", "d");

        if (this.checked) {
          searchState.od.terms.push(value);
        } else {
          searchState.od.terms = searchState.od.terms.filter(term => term !== value);
        }

        searchState.od.column = odID;
        searchTable();
      });
      filterODList.appendChild(li);
    });
    filterODGroup.classList.remove("hidden");
  } else {
    filterODGroup.classList.add("hidden");
  }

  const filterRangeGroup = document.querySelector("#filter-list .filter-range-group");
  const filterRangeList = document.querySelector("#filter-list .filter-range-group ul");
  filterRangeList.innerHTML = "";

  if (uniqueRange.length > 0) {
    uniqueRange.forEach((range, index) => {
      const li = createFilterButton("toggle-range", range, function() {
        if (this.checked) {
          searchState.range.terms.push(this.value);
        } else {
          searchState.range.terms = searchState.range.terms.filter(term => term !== this.value);
        }

        searchState.range.column = rangeID;
        searchTable();
      });
      filterRangeList.appendChild(li);
    });
    filterRangeGroup.classList.remove("hidden");
  } else {
    filterRangeGroup.classList.add("hidden");
  }

  if (dataTable) {
    dataTable = initDataTable($("#spec-sheet-table"));
    searchTable();
  }
}

if ($("#spec-sheet-table")) {

  fetch("/assets/products.json")
    .then(response => response.json())
    .then(data => {
      tableData = data;
      initSelectedState();
      changeSheetPerQueryString();
      loadData(selectedSheet);

      const myTable = document.querySelector("#spec-sheet-table");
      dataTable = initDataTable(myTable);

      let callResize;
      window.onresize = function(){
        clearTimeout(callResize);
        callResize = setTimeout(responsiveColumns, 100);
      };
    });

  $("input[name='specsheet-units']").addEventListener("change", function() {
    selectedState.imperial = !this.checked;
    if (selectedState.imperial) {
      window.system = "Imperial";
    } else {
      window.system = "Metric";
    }
    localStorage.setItem("imperial", !this.checked);
    loadData(selectedSheet);
  });

  $("input[name='specsheet-search']").addEventListener("keypress", function(event) {
    if (event.key === 'Enter') {
      searchState.search = this.value;
      searchTable();
    }
  });

  $("#specsheet-search-button").addEventListener("click", function() {
    searchState.search = $("input[name='specsheet-search']").value;
    searchTable();
  });

  $(".view-all-columns").addEventListener("click", function() {
    const columns = $$("#toggle-list input:not(:checked)");
    columns.forEach((column) => {
      const index = parseInt(column.value);

      if (!selectedState[selectedSheet]) {
        selectedState[selectedSheet] = [];
      }

      selectedState[selectedSheet][index] = true
      column.checked = true;
    });
    changeColumnDisplay();
  });

  $(".toggle-list-button").addEventListener("click", function() {
    const isExpanded = this.getAttribute("aria-expanded") === "true";
    this.setAttribute("aria-expanded", !isExpanded);
  });

  $(".filter-list-button").addEventListener("click", function() {
    const isExpanded = this.getAttribute("aria-expanded") === "true";
    this.setAttribute("aria-expanded", !isExpanded);
  });

  document.addEventListener("click", function(e) {
    const closest = e.target.closest(".column-toggles > div");

    if (!closest) {
      $(".toggle-list-button").setAttribute("aria-expanded", "false");
    }
  });

  document.addEventListener("click", function(e) {
    const closest = e.target.closest(".filter-toggles");

    if (!closest) {
      $(".filter-list-button").setAttribute("aria-expanded", "false");
    }
  });

  $$(".filter-close-button, .filter-apply-button").forEach(button => {
    button.addEventListener("click", function() {
      $(".filter-list-button").setAttribute("aria-expanded", "false");
    });
  });

  $(".filter-clear-button").addEventListener("click", function() {
    clearFilters();
    searchTable();
    $(".filter-list-button").setAttribute("aria-expanded", "false");
  });

  $$("#spec-sheet-tabs button").forEach(button => {
    button.addEventListener("click", function() {
      $$("#spec-sheet-tabs button").forEach(button => {
        button.setAttribute("aria-selected", "false");
      });

      this.setAttribute("aria-selected", "true");
      selectedSheet = this.dataset.label;
      loadData(selectedSheet);
      const url = new URL(window.location)
      url.searchParams.set("sheet", selectedSheet.replaceAll(" ", "-"));
      history.pushState(null, '', url);
    });
  });

  window.addEventListener("popstate", (event) => {
    changeSheetPerQueryString();
  });
}